import tagsPage from "./tagsPage"
export default tagsPage;
